import { IUser, User as CUser } from '../types';

const STORAGE_KEY = 'oauth.user';

export default class User implements CUser {
    id: string = null;
    email: string = null;
    name: string = null;
    surname: string = null;
    contact_phone: string = null;

    constructor({ id, email, name, surname, contact_phone }: IUser) {
        this.id = id;
        this.email = email;
        this.name = name;
        this.surname = surname;
        this.contact_phone = contact_phone;
    }

    static getFromLocalStorage(key: string = STORAGE_KEY): User {
        let data = window.localStorage.getItem(key);
        if (!data || data === 'undefined') {
            return null;
        }
        return new this(JSON.parse(data));
    }

    saveToLocalStorage(key: string = STORAGE_KEY): User {
        window.localStorage.setItem(key, JSON.stringify(this));
        return this;
    }
}
